import type { FilterState } from "../../../../../shared/components/FilterDrawer";
import type { DateRange } from "../../../../../shared/components/DurationSelector/types";
import type { MetricsFilters } from "../../../../../shared/api/types";

export const buildFilterParams = (
  filters: FilterState,
  dateRange: DateRange,
  clientId?: string | null
): MetricsFilters => {
  const [startDate, endDate] = dateRange;

  return {
    start_date: startDate ? startDate.format("YYYY-MM-DD") : undefined,
    end_date: endDate ? endDate.format("YYYY-MM-DD") : undefined,
    region: filters.region.length > 0 ? filters.region : undefined,
    depot: filters.depot.length > 0 ? filters.depot : undefined,
    department: filters.department.length > 0 ? filters.department : undefined,
    age_range: filters.ageRange.length > 0 ? filters.ageRange : undefined,
    sex: filters.sex.length > 0 ? filters.sex[0] : undefined,
    shift_pattern:
      filters.shiftPattern.length > 0 ? filters.shiftPattern : undefined,
    user_ids: filters.searchUser.length > 0 ? filters.searchUser : undefined,
    client_id: clientId !== undefined ? (clientId || null) : undefined,
  };
};
